import React, { ReactNode, useState } from 'react';

import * as S from './ThemeLogoIcon.styles';

export const ThemeLogoIcon = ({
  name,
  logo_url,
  isCondensed = false,
  fallbackIcon,
  size,
  isDisabled,
}: {
  name: string;
  logo_url?: string;
  isCondensed?: boolean;
  fallbackIcon?: ReactNode;
  size?: number;
  isDisabled?: boolean;
}) => {
  const [imageError, setImageError] = useState(false);

  return logo_url && !imageError ? (
    <S.StyledLogoImg
      src={logo_url}
      onError={() => setImageError(true)}
      $isCondensed={isCondensed}
      $size={size}
      $isDisabled={isDisabled}
    />
  ) : (
    <>
      {fallbackIcon ?? (
        <S.LogoFallback
          $isCondensed={isCondensed}
          $size={size}
          $isDisabled={isDisabled}
        >
          {name.charAt(0)}
        </S.LogoFallback>
      )}
    </>
  );
};

ThemeLogoIcon.Styled = S;
